import { useQuery } from 'query';

import { loadMetrics } from '../sources/loadMetrics';
import { metrics } from './queryKeyFactory';

export const useMetrics = () => {
  return useQuery(metrics, async () => {
    return loadMetrics();
  });
};
